import { TFunction } from 'i18next';
import { validPhoneRegex } from 'ud-form/components/input/domain/validators/phone';
import * as yup from 'yup';

import { AuthRequestAuthCodePayload } from '../interfaces/auth-request-auth-code-payload';

export const authRequestCodeValidator = (t: TFunction): yup.SchemaOf<AuthRequestAuthCodePayload> =>
  yup.object().shape({
    phone: yup
      .string()
      .required(t('signIn.validationError.phoneRequired'))
      .matches(validPhoneRegex, t('signIn.validationError.phoneInvalid')),
  });
